/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useAuth } from '../../../../app/modules/auth'
import Swal from 'sweetalert2'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { toAbsoluteUrl, KTIcon } from '../../../../_metronic/helpers'
import { fetchData, toasterrormsg, toastsuccessmsg } from '../../../../reusable'

interface PostReportMenuProps {
    postId: number
}

const PostReportMenu: FC<PostReportMenuProps> = ({ postId }) => {
    let t = Tr()
    const { currentUser } = useAuth()
    const [admindata, setadminData] = useState<any>(null)

    useEffect(() => {
        const tmp: any = sessionStorage.getItem('admin')
        if (tmp) {
            setadminData(JSON.parse(tmp))
        }
    }, [])

    const handleReportAction = async (reportType: 'false_information' | 'spam' | 'other') => {
        let swalOptions: any = {
            title: t('Report Post'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Submit Report'),
            cancelButtonText: t('Cancel'),
            customClass: {
                popup: 'swal-wide',
            },
        }

        // Configure based on report type
        switch (reportType) {
            case 'false_information':
                swalOptions = {
                    ...swalOptions,
                    html: `
                        <div class="text-start">
                            <p class="fw-bold mb-3">${t('Report Reason')}: ${t('False Information')}</p>
                            <label class="form-label required">${t('Please provide details about the false information')}</label>
                            <textarea 
                                id="swal-textarea" 
                                class="form-control form-control-solid" 
                                rows="4" 
                                placeholder="${t('Describe what information is false and why...')}"
                            ></textarea>
                        </div>
                    `,
                    preConfirm: () => {
                        const textarea = document.getElementById('swal-textarea') as HTMLTextAreaElement
                        const value = textarea?.value.trim()
                        if (!value) {
                            Swal.showValidationMessage(t('Please provide details about the false information'))
                            return false
                        }
                        return {
                            reportType: reportType,
                            description: value,
                        }
                    },
                }
                break

            case 'spam':
                swalOptions = {
                    ...swalOptions,
                    html: `
                        <div class="text-start">
                            <p class="fw-bold mb-3">${t('Report Reason')}: ${t('Spam')}</p>
                            <label class="form-label required">${t('Please provide details about the spam content')}</label>
                            <textarea 
                                id="swal-textarea" 
                                class="form-control form-control-solid" 
                                rows="4" 
                                placeholder="${t('Describe why this is spam...')}"
                            ></textarea>
                        </div>
                    `,
                    preConfirm: () => {
                        const textarea = document.getElementById('swal-textarea') as HTMLTextAreaElement
                        const value = textarea?.value.trim()
                        if (!value) {
                            Swal.showValidationMessage(t('Please provide details about the spam'))
                            return false
                        }
                        return {
                            reportType: reportType,
                            description: value,
                        }
                    },
                }
                break

            case 'other':
                swalOptions = {
                    ...swalOptions,
                    html: `
                        <div class="text-start">
                            <p class="fw-bold mb-3">${t('Report Reason')}: ${t('Other')}</p>
                            <div class="mb-4">
                                <label class="form-label required">${t('Report Title')}</label>
                                <input 
                                    id="swal-title" 
                                    class="form-control form-control-solid" 
                                    type="text" 
                                    placeholder="${t('Enter report title...')}"
                                />
                            </div>
                            <div>
                                <label class="form-label required">${t('Description')}</label>
                                <textarea 
                                    id="swal-description" 
                                    class="form-control form-control-solid" 
                                    rows="4" 
                                    placeholder="${t('Describe the issue...')}"
                                ></textarea>
                            </div>
                        </div>
                    `,
                    preConfirm: () => {
                        const titleInput = document.getElementById('swal-title') as HTMLInputElement
                        const descriptionTextarea = document.getElementById('swal-description') as HTMLTextAreaElement
                        
                        const title = titleInput?.value.trim()
                        const description = descriptionTextarea?.value.trim()

                        if (!title) {
                            Swal.showValidationMessage(t('Please provide a title'))
                            return false
                        }
                        if (!description) {
                            Swal.showValidationMessage(t('Please provide a description'))
                            return false
                        }

                        return {
                            reportType: reportType,
                            title: title,
                            description: description,
                        }
                    },
                }
                break
        }

        const result = await Swal.fire(swalOptions)

        if (result.isConfirmed && result.value) {
            await submitReport(postId, result.value)
        }
    }

    const submitReport = async (postId: number, reportData: any) => {
        try {
            const param = {
                postId: postId,
                adminId: admindata.adminId,
                violation: reportData.title || reportData.reportType,
                reason: reportData.description,
            }
         

            const response = await fetchData('admin/explore/post/report', param)

            if (String(response?.status) === '200') {
                toastsuccessmsg(response.message || t('Report submitted successfully'))
            } else {
                toasterrormsg(response?.message || t('Failed to submit report'))
            }
        } catch (error) {
            console.error('Error submitting report:', error)
            toasterrormsg(t('Something went wrong. Please try again.'))
        }
    }

    return (
        <div
            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-300px'
            data-kt-menu='true'
            data-popper-placement='bottom-start'
            id={`kt_post_report_menu_${postId}`}
        >
            {/* Menu Header */}
            <div className='menu-item px-3'>
                <div className='menu-content px-3 py-3'>
                    <div className='d-flex align-items-center'>
                        <KTIcon iconName='shield-cross' className='fs-1 text-danger me-2' />
                        <span className='fw-bold fs-5'>{t('Report Post')}</span>
                    </div>
                    
                </div>
            </div>

            <div className='separator mb-3'></div>

            {/* Report Options */}
            <div className='menu-item px-3'>
                <a
                    href='#'
                    className='menu-link px-3'
                    onClick={(e) => {
                        e.preventDefault()
                        handleReportAction('false_information')
                    }}
                >
                    <span className='menu-icon'>
                        <KTIcon iconName='information' className='fs-2 text-warning' />
                    </span>
                    <span className='menu-title'>{t('False Information')}</span>
                </a>
            </div>

            <div className='menu-item px-3'>
                <a
                    href='#'
                    className='menu-link px-3'
                    onClick={(e) => {
                        e.preventDefault()
                        handleReportAction('spam')
                    }}
                >
                    <span className='menu-icon'>
                        <KTIcon iconName='flag' className='fs-3 text-danger' />
                    </span>
                    <span className='menu-title'>{t('Spam')}</span>
                </a>
            </div>

            <div className='menu-item px-3'>
                <a
                    href='#'
                    className='menu-link px-3'
                    onClick={(e) => {
                        e.preventDefault()
                        handleReportAction('other')
                    }}
                >
                    <span className='menu-icon'>
                        <KTIcon iconName='menu' className='fs-3 text-primary' />
                    </span>
                    <span className='menu-title'>{t('Other')}</span>
                </a>
            </div>
        </div>
    )
}

export { PostReportMenu }